/**
 * Mock implementation of the Platform module for web
 */
const Platform = {
  OS: 'web',
  select: function(obj) {
    return obj.web || obj.default || null;
  },
  Version: 1,
  isTesting: false,
  isTV: false,
  isPad: false,
  isTablet: false,
  constants: {
    reactNativeVersion: {
      major: 0,
      minor: 74,
      patch: 5
    }
  }
};

module.exports = Platform;